module.exports = __webpack_public_path__ + "img/card-basic-clock.8c9bdd3e.jpg";